var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.componentReady)?_c('div',{staticClass:"container-wrapper"},[_c('BackLink',{attrs:{"text":_vm.backLinkText}}),_c('section',{staticClass:"container policy-page"},[_c('h1',{staticClass:"policy-page__title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"policy-page__content",domProps:{"innerHTML":_vm._s(_vm.content)}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }